import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteCategory } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

const useForceDeleteCategory = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteCat,
        isPending: isForceDelete,
    } = useMutation({
        mutationFn: forceDeleteCategory,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to permanently delete category");
        },
    });

    return {
        forceDeleteCat,
        isForceDelete,
    };
};

export default useForceDeleteCategory;
